import { useQuery } from "@apollo/client";
import { GET_PARTICIPANTS_SUMMARY } from "../api/get-participants-summary";

export function useParticipantsSummary({ id }: { id: string }) {
  const { data } = useQuery(GET_PARTICIPANTS_SUMMARY, {
    variables: { id },
  });

  const count = data?.getCompanyDocumentById.confirmationInfoCount;
  const total = count?.total ?? 0;
  const read = count?.read ?? 0;
  const unread = count?.unread ?? 0;

  const percent = (value: number) =>
    total ? Math.round((value / total) * 1000) / 10 : 0;

  return {
    total,
    read,
    unread,
    readPercent: percent(read),
    unreadPercent: percent(unread),
  };
}
